export default "__VITE_ASSET__Dl6pS_AS__"